import { createContext, type MutableRefObject } from 'react';

export interface PendingBreadcrumbFocus {
  path: string | null;
  element: HTMLElement;
}

export const BreadcrumbFocusContext = createContext<MutableRefObject<PendingBreadcrumbFocus | null> | null>(null);
